import React, { Component } from 'react'

import './home/css/bootstrap.css'
import './home/css/fontawesome-all.css'
import './home/css/magnific-popup.css'
import './home/css/styles.css'

import "bootstrap/dist/css/bootstrap.min.css"

import logo from './home/images/logo.png'

class Navbar extends Component {
  render() {
    return (
      <div>
        <nav className="navbar navbar-expand-md navbar-dark navbar-custom fixed-top" id="navBarID">
          <a className="navbar-brand logo-image" href="/"><img src={logo} alt="alternative" /></a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-awesome fas fa-bars"></span>
            <span className="navbar-toggler-awesome fas fa-times"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarsExampleDefault">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle page-scroll" id="navbarDropdown" role="button" aria-haspopup="true" aria-expanded="false">ABOUT</a>
                <div className="dropdown-menu navDropTC" aria-labelledby="navbarDropdown">
                  <a className="dropdown-item" href="/terms-conditions"><span className="item-text">TERMS CONDITIONS</span></a>
                  <div className="dropdown-items-divide-hr"></div>
                  <a className="dropdown-item" href="/rules"><span className="item-text">RULES</span></a>
                </div>
              </li>

              <li className="nav-item">
                <a className="nav-link page-scroll" href="/memberships">MEMBERSHIPS</a>
              </li>
              <li className="nav-item">
                <a className="nav-link page-scroll" href="/venue-sign-up">VENUE PARTNERSHIPS</a>
              </li>
            </ul>
            <span className="nav-item social-icons">
              <span className="fa-stack">
                <a href="https://www.facebook.com/seatstir/" target="_blank" rel="noreferrer">
                  <span className="hexagon"></span>
                  <i className="fab fa-facebook-f fa-stack-1x"></i>
                </a>
              </span>
              <span className="fa-stack">
                <a href="https://twitter.com/logi_g" target="_blank" rel="noreferrer">
                  <span className="hexagon"></span>
                  <i className="fab fa-twitter fa-stack-1x"></i>
                </a>
              </span>
            </span>
          </div>
        </nav>
      </div>
    )
  }
}

export default Navbar